namespace $ {

	export class $shm_hitalama_map_history_storage_page extends $giper_baza_entity.with({
		Entries: $giper_baza_list_dict,
	}) {

		entries() {
			this.keys()
			return this.Entries()?.items() as readonly $shm_hitalama_map_history_summary[] ?? []
		}

	}

}
